import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "@helpers/translate";

import { CopyModalContext } from "./components/CopyContext";

import { InternalContent } from "@components/library";
import {
  CopytradeHero,
  Copytraders,
  CopytradeFAQ,
  CopytradeFollowTraders,
  CopyTraderModal,
} from "./components";

import "./Copytrade.sass";

export const Copytrade = () => {
  const { __ } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTrader, setSelectedTrader] = useState("");

  return (
    <CopyModalContext.Provider value={{ setIsModalOpen, setSelectedTrader }}>
      <InternalContent>
        <Helmet>
          <title>
            {__("seo.copytrade")} {__("seo.divider")} {__("seo.title")}
          </title>
        </Helmet>

        <div className="copytrade">
          <CopytradeHero />

          <Copytraders onOpenModal={() => setIsModalOpen(true)} />

          <CopytradeFollowTraders />

          <CopytradeFAQ />
        </div>

        <CopyTraderModal
          active={isModalOpen}
          setActive={setIsModalOpen}
          traderName={selectedTrader}
        />
      </InternalContent>
    </CopyModalContext.Provider>
  );
};
